<div class="row form-property  {{property?.styleClass ? property.styleClass : ''}}">
  <div
    class="col-lg-{{tooltip?10:12}}"
    [ngClass]="{'no-padding-right':tooltip}"
  >
    <ng-container *ngIf="!leftLabel">
      <span class="p-float-label">
        <p-calendar
          *ngIf="!property.rowspan"
          id="{{name}}"
          [appendTo]="'body'"
          class="ui-inputwrapper-focus ui-inputwrapper-focus"
          (ngModelChange)="change($event)"
          [(ngModel)]="date"
          [showIcon]="property.showIcon"
          [disabled]="property.readOnly"
          [disabledDates]="property.disabledDates"
          [style]="{'width': '95%'}"
          [inputStyleClass]="readonly?'disabled':''"
          [ngClass]="{'calendar-property-invalid':notValid}"
          [inline]="property.inline"
          [minDate]="property.minDate"
          [maxDate]="property.maxDate"
          [view]="property.calendarView ? property.calendarView : 'date'"
          [dateFormat]="property.dateFormat ? property.dateFormat : 'mm/dd/yy'"
          [yearNavigator]="property.yearNavigator ? property.yearNavigator : false"
          [yearRange]="property.yearRange ? property.yearRange : null"
          [readonlyInput]="property.readonlyInput ? property.readonlyInput : null"
        >
        </p-calendar>
        <label class="gs-float-label {{property?.labelClass ? property.labelClass : ''}}" [ngClass]="{'error-color':notValid}">{{label}}</label>
        <span
          *ngIf="notValid && property.validationMessage"
          class="form-error"
          pTooltip="{{property.validationMessage}}"
          tooltipPosition="top"
        >
          <i
            style="margin-right: 15px"
            class="fas fa-info-circle fa-2x form-valid-icon with-icon error-color"
          ></i>
        </span>
      </span>
    </ng-container>
    <ng-container *ngIf="leftLabel">
      <label class="master-font" [ngClass]="{'error-color':notValid}"
        >{{label}}</label
      >
      <span class="float-right">
        <p-calendar
          *ngIf="!property.rowspan"
          id="{{name}}"
          class="ui-inputwrapper-focus ui-inputwrapper-focus"
          (ngModelChange)="change($event)"
          [(ngModel)]="date"
          [showIcon]="property.showIcon"
          [disabled]="property.readOnly"
          [style]="{'width': '95%'}"
          [inline]="property.inline"
        ></p-calendar>
      </span>
    </ng-container>
  </div>
  <div *ngIf="tooltip" class="col-lg-2 property-tooltip">
    <span pTooltip="{{property.tooltip}}">
      <i class="fas fa-info-circle master-color"></i>
    </span>
  </div>
</div>
